var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asideNavWrapper"},_vm._l((_vm.menus),function(menu,idx){return _c('router-link',{key:idx,class:{ linkItem: true, active: _vm.$route.path === menu.link },attrs:{"to":menu.link,"exact":true}},[_c('img',{staticClass:"icon",attrs:{"src":menu.icon,"alt":""}}),_c('span',[_vm._v(_vm._s(menu.title))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }